import { render, staticRenderFns } from "./EditR.vue?vue&type=template&id=1871515f"
import script from "./EditR.vue?vue&type=script&lang=js"
export * from "./EditR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports